import { MouseEvent, useEffect, useState } from "react";
import { Checkbox } from "@allaria-tech/matter/Checkbox";
import { Modal } from "@allaria-tech/matter/Modal";
import { Typography } from "@allaria-tech/matter/Typography";

import { falFundSelectionCopy } from "../../i18n/falFundSelection";
import { FalFund } from "../../utils/falFunds";

import styles from "./FalFundSelectionPage.module.scss";

const copy = falFundSelectionCopy.confirmation;

interface Props {
  fund: FalFund | null;
  holder: string;
  isSubmitting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const FalFundConfirmModal = ({
  fund,
  holder,
  isSubmitting,
  onCancel,
  onConfirm,
}: Props) => {
  const { confirmation, highlight, acceptanceLabel, regulationLink } = styles;
  const [accepted, setAccepted] = useState(false);

  useEffect(() => setAccepted(false), [fund]);

  const name = fund?.nombre ?? "";

  // The link sits inside the checkbox label: open the PDF without toggling it.
  const openRegulation = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (fund?.urlReglamento)
      window.open(fund.urlReglamento, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal
      isOpen={Boolean(fund)}
      title={copy.title}
      testId="fal-confirm"
      isDismissable={!isSubmitting}
      hideCloseButton={isSubmitting}
      onClose={onCancel}
      footerAlignment="center"
      secondaryAction={{
        text: copy.back,
        isDisabled: isSubmitting,
        onClick: onCancel,
      }}
      primaryAction={{
        text: copy.confirm,
        isDisabled: !accepted || isSubmitting,
        isLoading: isSubmitting,
        onClick: onConfirm,
      }}
    >
      <div className={confirmation}>
        <Typography type="BODY" size="S" tag="p">
          {copy.chose} <span className={highlight}>{name}</span>{" "}
          {copy.forAccount} <span className={highlight}>{holder}</span>
        </Typography>
        <Checkbox
          name="fal-acceptance"
          variant="simple"
          testId="fal-acceptance"
          checked={accepted}
          onCheckedChange={() => setAccepted((current) => !current)}
          label={
            <span className={acceptanceLabel}>
              {copy.acceptance} <b>{name}</b> {copy.andAccept}{" "}
              {fund?.urlReglamento ? (
                <span className={regulationLink} onClick={openRegulation}>
                  {copy.regulation}
                </span>
              ) : (
                copy.regulation
              )}
            </span>
          }
        />
      </div>
    </Modal>
  );
};

export default FalFundConfirmModal;
